export default "__VITE_ASSET__3282bbbf__"